var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretCircleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    id: "caret-circle-left",
    fill: "black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M106.64844,122.05469l40-36a7.99912,7.99912,0,1,1,10.70312,11.89062L115.96094,128l40,36a7.99912,7.99912,0,1,1-10.70312,11.89062l-40-36A7.99734,7.99734,0,0,1,106.64844,122.05469Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretCircleLeft);
export default __webpack_public_path__ + "static/media/caret-circle-left.917d92ba023c1c1f3656858c4059d468.svg";
export { ForwardRef as ReactComponent };